import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss'],
})
export class history implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
